import GenericModel from './generic-model';
import { User } from './user';
import Asset from './asset';
import RegisteredActionType from './registered-action-type';
import { Moment } from 'moment';

export default class RegisteredAction extends GenericModel {
  user?: User;
  date?: Date;
  asset?: Asset;
  type?: RegisteredActionType;
  actualDate?: Moment;
  localUuid?: string;
}
